import {useContext, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {SheetContext, SheetEditContext} from '../SheetContexts'

const PreviewModalHeader = () => {
  const {closePreviewModal, previewMode} = useContext(SheetEditContext)
      console.log(previewMode)


  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Vista {previewMode}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closePreviewModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {PreviewModalHeader}
